export default __webpack_public_path__ + "static/media/client.dd9b3141.svg";